import { render } from "./projectEmployeeList.vue?vue&type=template&id=56eaa43e"
import script from "./projectEmployeeList.vue?vue&type=script&lang=js"
export * from "./projectEmployeeList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\VueTemplate\\A1Catering\\a1cateringadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__